var React = require('react');

function IconEnvelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.75 17.456l-4.581-5.887L18.75 8.1v9.356zM1.906 18.75l4.807-6.181 2.65 2.137.287.288.037-.025.038.025.219-.219 3.181-2.413 4.969 6.388H1.906zM1.25 8.156l4.444 3.588-4.444 5.712v-9.3zM10 1.25l8.494 5.456-8.775 6.656-2.225-1.793v-.007l-.938-.93-.087.112-4.981-4.025L10 1.25zM10 0L0 6.25V20h20V6.25L10 0z","fillRule":"nonzero"}));
}

IconEnvelope.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = IconEnvelope;

IconEnvelope.default = IconEnvelope;
